import { Helmet } from "react-helmet";
import Footer from "../components/footer/Footer";
import Header from "../components/navbar/Header";
import AOS from "aos";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useRef } from "react";
import "aos/dist/aos.css";
import { useEffect } from "react";
import awardSvg1 from "../assets/awards/1.svg";
import awardSvg2 from "../assets/awards/2.svg";
import awardSvg3 from "../assets/awards/3.svg";
import awardSvg4 from "../assets/awards/4.svg";
import awardSvg5 from "../assets/awards/5.svg";
import awardSvg6 from "../assets/awards/6.svg";

import awardSvg8 from "../assets/awards/8.svg";
import awardSvg9 from "../assets/awards/9.svg";
import awardSvg10 from "../assets/awards/10.svg";
import awardSvg11 from "../assets/awards/11.svg";
import awardSvg12 from "../assets/awards/12.svg";
import awardSvg13 from "../assets/awards/13.svg";
import awardSvg14 from "../assets/awards/14.svg";

export const awards = [
  awardSvg1,
  awardSvg2,
  awardSvg3,
  awardSvg4,
  awardSvg5,
  awardSvg6,
  awardSvg8,
  awardSvg9,
  awardSvg10,
  awardSvg11,
  awardSvg12,
  awardSvg13,
  awardSvg14,
  require("../assets/awards/1.jpeg"),
  require("../assets/awards/2.jpeg"),
  require("../assets/awards/3.jpeg"),
  require("../assets/awards/4.jpeg"),
  require("../assets/awards/5.jpeg"),
  require("../assets/awards/6.jpeg"),
  require("../assets/awards/7.jpeg"),
  require("../assets/awards/8.jpeg"),
  require("../assets/awards/9.jpeg"),
  require("../assets/awards/10.jpeg"),
  require("../assets/awards/11.jpeg"),
  require("../assets/awards/12.jpeg"),
  require("../assets/awards/13.jpeg"),
  require("../assets/awards/14.jpeg"),
];

const About = () => {
  const [showAllAwards] = useState(false);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  const awards = [
    {
      img: awardSvg1,
      title: "Dealer within a region with maximum sales to service ratio",
    },
    { img: awardSvg2, title: "Highest number of MSD activations" },
    {
      img: awardSvg3,
      title:
        "Dealer within a region of maximum Sales Service ration (Annual Retails Category 7500 Vehicles)",
    },
    {
      img: awardSvg4,
      title:
        "Overall Performance in Service Workshop with Service Load between 500 and 1000",
    },
    { img: awardSvg5, title: " Highest MI Penetration" },
    { img: awardSvg6, title: "Highest AGS Sales -2" },
    { img: awardSvg8, title: "Highest Paid Corporate Training" },
    { img: awardSvg9, title: "Highest Workshop Conversion Ratio" },
    { img: awardSvg10, title: "Outstanding Sales Performance Q2" },
    { img: awardSvg11, title: "Best ISL initative-RO city" },
    { img: awardSvg12, title: "HIGHEST CORPORATE PENETRATION" },
    { img: awardSvg13, title: "Best Performance in Fleet-RO City" },
    { img: awardSvg14, title: "Highest Retail Growth Non RO City" },

    // JPEG images
    { img: require("../assets/awards/1.jpeg"), title: "Award Title 1" },
    { img: require("../assets/awards/2.jpeg"), title: "Award Title 2" },
    { img: require("../assets/awards/3.jpeg"), title: "Award Title 3" },
    { img: require("../assets/awards/4.jpeg"), title: "Award Title 4" },
    { img: require("../assets/awards/5.jpeg"), title: "Award Title 5" },
    { img: require("../assets/awards/6.jpeg"), title: "Award Title 6" },
    { img: require("../assets/awards/7.jpeg"), title: "Award Title 7" },
    { img: require("../assets/awards/8.jpeg"), title: "Award Title 8" },
    { img: require("../assets/awards/9.jpeg"), title: "Award Title 9" },
    { img: require("../assets/awards/10.jpeg"), title: "Award Title 10" },
    { img: require("../assets/awards/11.jpeg"), title: "Award Title 11" },
    { img: require("../assets/awards/12.jpeg"), title: "Award Title 12" },
    { img: require("../assets/awards/13.jpeg"), title: "Award Title 13" },
    { img: require("../assets/awards/14.jpeg"), title: "Award Title 14" },
  ];

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-in-out",
      once: false, // animate while scrolling up & down
      mirror: true, // element animates out when leaving viewport
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Trusted Maruti Suzuki Car Dealers in Hyderabad | Maruti Suzuki Cars
          Hyderabad
        </title>
        <meta
          name="title"
          content="Trusted Maruti Suzuki Car Dealers in Hyderabad | Maruti Suzuki Cars Hyderabad"
        />
        <meta
          name="description"
          content="Gem Maruti – Trusted Maruti Suzuki Car Dealers in Hyderabad. Visit GEM Maruti Suzuki Showroom today and test drive your favourite Maruti car."
        />
      </Helmet>

      <Header />

      <div className="px-5 lg:px-0">
        <div className="container mx-auto mt-16 mb-8">
          <div className="flex justify-center">
            <h2 className="text-2xl font-semibold text-[#DC2627]">About Us</h2>
          </div>

          <div className="relative">
            <div className="h-1 bg-[#DC2627] mt-3 max-w-[100px] mx-auto"></div>
          </div>
          <p className="uppercase font-semibold text-4xl text-center mt-8">
            Welcome to GEM Motors
          </p>
        </div>

        <div className="max-w-screen-xl mx-auto px-5 space-y-12">
          {/* MD SECTION */}
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div className="col-span-1 my-auto">
              <p className="font-semibold lg:text-4xl">
                Meet Our Managing Director
              </p>
              <p className="mt-8 leading-relaxed">
                <strong>Mr. E. Raju Yadav</strong>, a distinguished entrepreneur
                with more than two decades of experience across entertainment,
                infrastructure, and hospitality , leads GEM Motors with vision
                and passion.
                <br />
                <br />
                Born and raised in Hyderabad, he possesses deep market insights
                and strong business acumen. In 2007, he took charge of GEM
                Motors and transformed it into one of the most trusted
                automotive brands in the region .
                <br />
                <br />
                Under his leadership,GEM Motors successfully expanded into{" "}
                Arena, Nexa, True Value, Commercial, and Suzuki Motorcycle
                dealerships. His strategic thinking and customer-first approach
                excellence.
              </p>
            </div>

            <div className="col-span-1">
              <img
                src={require("../assets/About/md.png")}
                className="mx-auto rounded-lg h-[500px] w-full object-cover object-top"
                loading="lazy"
                alt="Managing Director"
              />
            </div>
          </div>
          <section className="max-w-screen-xl mx-auto px-5 py-20">
            <h2 className="text-3xl lg:text-4xl font-bold text-center">
              Our Journey
            </h2>
            <div className="bg-red-600 h-1 w-20 mx-auto mt-2 mb-12 rounded"></div>

            <div className="relative">
              {/* Vertical Timeline Line */}
              <div className="absolute left-1/2 top-0 bottom-0 transform -translate-x-1/2 w-1 bg-red-600 rounded-full"></div>

              <div className="space-y-32">
                {/* ===================================================== */}
                {/*                  2007 LEFT → RIGHT                    */}
                {/* ===================================================== */}
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 relative">
                  {/* LEFT TEXT */}
                  <div className="lg:pr-10 lg:text-right" data-aos="fade-right">
                    <div className="bg-white shadow-lg p-6 rounded-lg hover:shadow-xl transition">
                      <h3 className="text-xl font-semibold">The Beginning</h3>
                      <p className="mt-3 text-gray-700">
                        GEM Motors began its journey in Hyderabad’s IT Hub with
                        a premium Maruti Suzuki showroom and world-class
                        workshops.
                      </p>
                    </div>
                  </div>

                  {/* YEAR CIRCLE */}
                  <div className="absolute left-1/2 -translate-x-1/2 -top-5 lg:top-1/2 lg:-translate-y-1/2 z-10">
                    <div
                      className="bg-red-600 text-white w-16 h-16 rounded-full flex items-center 
          justify-center font-bold shadow-xl text-lg"
                    >
                      2007
                    </div>
                  </div>

                  {/* RIGHT IMAGE */}
                  <div className="lg:pl-10" data-aos="fade-left">
                    <img
                      src={require("../assets/About/The-Beginning.webp")}
                      className="rounded-lg shadow-lg h-[260px] w-full object-cover"
                      alt="2007"
                    />
                  </div>
                </div>

                {/* ===================================================== */}
                {/*                  2008 RIGHT → LEFT                    */}
                {/* ===================================================== */}
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 relative">
                  {/* LEFT IMAGE */}
                  <div
                    className="lg:pr-10 order-last lg:order-first"
                    data-aos="fade-right"
                  >
                    <img
                      src={require("../assets/About/True-Value-Launched.webp")}
                      className="rounded-lg shadow-lg h-[260px] w-full object-cover"
                      alt="2008"
                    />
                  </div>

                  {/* YEAR CIRCLE */}
                  <div className="absolute left-1/2 -translate-x-1/2 -top-5 lg:top-1/2 lg:-translate-y-1/2 z-10">
                    <div
                      className="bg-red-600 text-white w-16 h-16 rounded-full flex items-center 
          justify-center font-bold shadow-xl text-lg"
                    >
                      2008
                    </div>
                  </div>

                  {/* RIGHT TEXT */}
                  <div className="lg:pl-10" data-aos="fade-left">
                    <div className="bg-white shadow-lg p-6 rounded-lg hover:shadow-xl transition">
                      <h3 className="text-xl font-semibold">
                        True Value Launched
                      </h3>
                      <p className="mt-3 text-gray-700">
                        Introduced Maruti Suzuki True Value and won the
                        prestigious “Best Dealer Award.”
                      </p>
                    </div>
                  </div>
                </div>

                {/* ===================================================== */}
                {/*                  2015 LEFT → RIGHT                    */}
                {/* ===================================================== */}
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 relative">
                  {/* LEFT TEXT */}
                  <div className="lg:pr-10 lg:text-right" data-aos="fade-right">
                    <div className="bg-white shadow-lg p-6 rounded-lg hover:shadow-xl transition">
                      <h3 className="text-xl font-semibold">
                        Expansion Into Two-Wheelers
                      </h3>
                      <p className="mt-3 text-gray-700">
                        Started Gem Automotive LLP — Authorized Suzuki
                        Motorcycle dealers.
                      </p>
                    </div>
                  </div>

                  {/* YEAR CIRCLE */}
                  <div className="absolute left-1/2 -translate-x-1/2 -top-5 lg:top-1/2 lg:-translate-y-1/2 z-10">
                    <div
                      className="bg-red-600 text-white w-16 h-16 rounded-full flex items-center 
          justify-center font-bold shadow-xl text-lg"
                    >
                      2015
                    </div>
                  </div>

                  {/* RIGHT IMAGE */}
                  <div className="lg:pl-10" data-aos="fade-left">
                    <img
                      src={require("../assets/About/Expansion-Into-Two-Wheelers.webp")}
                      className="rounded-lg shadow-lg h-[260px] w-full object-cover"
                      alt="2015"
                    />
                  </div>
                </div>

                {/* ===================================================== */}
                {/*                  2018 RIGHT → LEFT                    */}
                {/* ===================================================== */}
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 relative">
                  {/* LEFT IMAGE */}
                  <div
                    className="lg:pr-10 order-last lg:order-first"
                    data-aos="fade-right"
                  >
                    <img
                      src={require("../assets/About/Nexa-&-New-Expansions.webp")}
                      className="rounded-lg shadow-lg h-[260px] w-full object-cover"
                      alt="2018"
                    />
                  </div>

                  {/* YEAR CIRCLE */}
                  <div className="absolute left-1/2 -translate-x-1/2 -top-5 lg:top-1/2 lg:-translate-y-1/2 z-10">
                    <div
                      className="bg-red-600 text-white w-16 h-16 rounded-full flex items-center 
          justify-center font-bold shadow-xl text-lg"
                    >
                      2018
                    </div>
                  </div>

                  {/* RIGHT TEXT */}
                  <div className="lg:pl-10" data-aos="fade-left">
                    <div className="bg-white shadow-lg p-6 rounded-lg hover:shadow-xl transition">
                      <h3 className="text-xl font-semibold">
                        Nexa & New Expansions
                      </h3>
                      <p className="mt-3 text-gray-700">
                        Expanded into Manikonda, Sun City, Chevella, Vikarabad,
                        and more.
                      </p>
                    </div>
                  </div>
                </div>

                {/* ===================================================== */}
                {/*                  2025 LEFT → RIGHT                    */}
                {/* ===================================================== */}
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 relative">
                  {/* LEFT TEXT */}
                  <div className="lg:pr-10 lg:text-right" data-aos="fade-right">
                    <div className="bg-white shadow-lg p-6 rounded-lg hover:shadow-xl transition">
                      <h3 className="text-xl font-semibold">
                        Best Value Launched
                      </h3>
                      <p className="mt-3 text-gray-700">
                        Introduced Best Value — A dedicated platform for
                        pre-owned motorcycles.
                      </p>
                    </div>
                  </div>

                  {/* YEAR */}
                  <div className="absolute left-1/2 -translate-x-1/2 -top-5 lg:top-1/2 lg:-translate-y-1/2 z-10">
                    <div
                      className="bg-red-600 text-white w-16 h-16 rounded-full flex items-center 
          justify-center font-bold shadow-xl text-lg"
                    >
                      2025
                    </div>
                  </div>

                  {/* RIGHT IMAGE */}
                  <div className="lg:pl-10" data-aos="fade-left">
                    <img
                      src={require("../assets/About/Best-Value-Launched.webp")}
                      className="rounded-lg shadow-lg h-[260px] w-full object-cover"
                      alt="2025"
                    />
                  </div>
                </div>

                {/* ===================================================== */}
                {/*                       NOW                             */}
                {/* ===================================================== */}
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 relative">
                  {/* LEFT IMAGE */}
                  <div
                    className="lg:pr-10 order-last lg:order-first"
                    data-aos="fade-right"
                  >
                    <img
                      src={require("../assets/About/A_Trusted-Automotive-Leader.webp")}
                      className="rounded-lg shadow-lg h-[260px] w-full object-cover"
                      alt="Now"
                    />
                  </div>

                  {/* YEAR */}
                  <div className="absolute left-1/2 -translate-x-1/2 -top-5 lg:top-1/2 lg:-translate-y-1/2 z-10">
                    <div
                      className="bg-red-600 text-white w-16 h-16 rounded-full flex items-center 
          justify-center font-bold shadow-xl text-lg"
                    >
                      Now
                    </div>
                  </div>

                  {/* RIGHT TEXT */}
                  <div className="lg:pl-10" data-aos="fade-left">
                    <div className="bg-white shadow-lg p-6 rounded-lg hover:shadow-xl transition">
                      <h3 className="text-xl font-semibold">
                        A Trusted Automotive Leader
                      </h3>
                      <p className="mt-3 text-gray-700">
                        Today, GEM Motors stands as a leading automotive
                        powerhouse built on trust, innovation, and two decades
                        of excellence.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* WHY CHOOSE US */}
          {/* ------------------- WHY CHOOSE US ------------------- */}
          <section className="max-w-screen-xl mx-auto px-5 py-16">
            <h2
              className="text-3xl lg:text-4xl font-bold text-center"
              data-aos="fade-up"
            >
              Why Choose Us?
            </h2>

            <div
              className="bg-red-600 h-1 w-20 mx-auto mt-2 mb-10 rounded"
              data-aos="fade-up"
            ></div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div
                data-aos="fade-right"
                data-aos-delay="200"
                className="w-full"
              >
                <img
                  src={require("../assets/About/The-Beginning.webp")}
                  className="rounded-lg shadow-lg w-full h-[450px] object-cover"
                  alt="Why Choose GEM Motors"
                />
              </div>

              {/* LEFT — Text + Icons */}
              <div
                className="space-y-6 text-gray-700 leading-relaxed"
                data-aos="fade-left"
              >
                <p className="text-lg">
                  Choosing <strong>GEM Motors</strong> means choosing a partner
                  built on
                  <strong> trust, innovation, reliability</strong> and a{" "}
                  <strong>proven legacy of excellence.</strong>
                </p>

                <ul className="space-y-4">
                  <li className="flex items-start space-x-3">
                    <span className="text-red-600 text-2xl">✓</span>
                    <p>
                      <strong>Trusted Legacy Since 2007</strong> with excellence
                      across Arena, Nexa, True Value & Suzuki Motorcycles.
                    </p>
                  </li>

                  <li className="flex items-start space-x-3">
                    <span className="text-red-600 text-2xl">✓</span>
                    <p>
                      <strong>Customer-Centric Approach</strong> — majority of
                      our business comes from referrals & repeat customers.
                    </p>
                  </li>

                  <li className="flex items-start space-x-3">
                    <span className="text-red-600 text-2xl">✓</span>
                    <p>
                      <strong>Innovative Services</strong> such as Sunday
                      Service & Night Service — later adopted nationwide.
                    </p>
                  </li>

                  <li className="flex items-start space-x-3">
                    <span className="text-red-600 text-2xl">✓</span>
                    <p>
                      <strong>Quality & Reliability</strong> based on integrity,
                      hard work, and continuous improvement.
                    </p>
                  </li>

                  <li className="flex items-start space-x-3">
                    <span className="text-red-600 text-2xl">✓</span>
                    <p>
                      <strong>Modern Facilities</strong> offering comfort,
                      transparency, and efficiency.
                    </p>
                  </li>

                  <li className="flex items-start space-x-3">
                    <span className="text-red-600 text-2xl">✓</span>
                    <p>
                      <strong>Wide Network</strong> across Telangana for
                      convenient access.
                    </p>
                  </li>

                  <li className="flex items-start space-x-3">
                    <span className="text-red-600 text-2xl">✓</span>
                    <p>
                      <strong>Dedicated Teams</strong> ensuring a smooth,
                      seamless buying & ownership experience.
                    </p>
                  </li>
                </ul>
              </div>

              {/* RIGHT — Image */}
            </div>
          </section>

          {/* ACHIEVEMENTS */}
          {/* ACHIEVEMENTS */}
          <div className="my-10 relative group">
            <h3 className="xl:text-3xl md:text-xl text-lg font-medium text-center">
              Awards
            </h3>
            <div className="bg-red-600 h-1 lg:w-[100px] rounded-full w-20 mx-auto my-1"></div>

            <Swiper
              modules={[Navigation, Autoplay]}
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              // navigation={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              spaceBetween={30}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
              className="my-10 "
            >
              {(showAllAwards ? awards : awards.slice(0, 8)).map(
                (award, index) => (
                  <SwiperSlide key={index} className="h-full">
                    <div
                      className="bg-[#F6F6F6] rounded-xl 
    hover:shadow-2xl transition-all duration-300
    p-6 text-center h-full flex flex-col mb-3"
                    >
                      <img
                        src={award.img}
                        alt={award.title}
                        className="w-full h-[220px] object-contain mx-auto hover:scale-125 hover:duration-1000 "
                      />

                      <div className="flex justify-center mt-4 mb-2">
                        <div className="w-12 h-[2px] bg-black"></div>
                      </div>

                      {/* FIXED HEIGHT TEXT */}
                      <div className="flex items-center justify-center h-[48px]">
                        <p className="text-[14px] font-medium text-gray-800 px-2 line-clamp-2">
                          {award.title}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                ),
              )}
            </Swiper>
            {/* Navigation Buttons */}
            {/* CUSTOM NAVIGATION BUTTONS */}
            <div
              ref={prevRef}
              className="
    absolute top-1/2 -translate-y-1/2 left-2 z-20
    bg-black/60 hover:bg-black text-white
    p-3 rounded-full cursor-pointer
    opacity-0 group-hover:opacity-100
    transition duration-300
  "
            >
              ❮
            </div>

            <div
              ref={nextRef}
              className="
    absolute top-1/2 -translate-y-1/2 right-2 z-20
    bg-black/60 hover:bg-black text-white
    p-3 rounded-full cursor-pointer
    opacity-0 group-hover:opacity-100
    transition duration-300
  "
            >
              ❯
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default About;
